await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-taglib/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export function isDataLayoutEmpty(dataLayoutPages) {
	return dataLayoutPages.every(({dataLayoutRows}) => {
		return dataLayoutRows.every(({dataLayoutColumns}) => {
			return dataLayoutColumns.every(({fieldNames = []}) => {
				return !fieldNames.length;
			});
		});
	});
}
